import React from 'react'
import { FormattedMessage } from 'react-intl'

// Components
import { IconExclamationTriangle } from 'src/Components/shared/Icon'
import { Text, Button } from 'src/Components'

// Helpers
import { requestMailTo } from 'src/api/iframe/requests'
import { useSignUpProvider } from '../SignUpContext'

// styles
import styles from './ErrorContents.module.scss'

const EmailButton = () => {
  const supportEmailUrl = 'support@homebot.ai'
  return (
    <Button onClick={() => requestMailTo(supportEmailUrl)} minimal>
      {supportEmailUrl}
    </Button>
  )
}

const SupportEmail = () => (
  <FormattedMessage
    id='Chromebot.landingPage.steps.failureSubmit.supportEmailLink'
    defaultMessage='reach out to {emailButton}'
    values={{
      emailButton: <EmailButton />,
    }}
  />
)

const ErrorContents = () => {
  const { handleCreateClick, loading } = useSignUpProvider()

  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <IconExclamationTriangle className={styles.triangle} />
        <Text variant='neutralCool' variantCount='900' weight='bold' size='l'>
          <FormattedMessage
            id='Chromebot.landingPage.steps.failureSubmit.header'
            defaultMessage='Something went wrong'
          />
        </Text>
        <Text variant='neutralCool' variantCount='600'>
          <FormattedMessage
            id='Chromebot.landingPage.steps.failureSubmit.retry'
            defaultMessage="Let's see if we can try again"
          />
        </Text>
        <Button
          wide
          className={styles.retryButton}
          loading={loading}
          onClick={handleCreateClick}
        >
          Retry
        </Button>
      </div>
      <hr />
      <div className={styles.bottom}>
        <Text
          variant='neutralCool'
          variantCount='600'
          className={styles.reachOut}
        >
          <FormattedMessage
            id='Chromebot.landingPage.steps.failureSubmit.message'
            defaultMessage='If the problem continues,'
          />{' '}
        </Text>
        <Text variant='neutralCool' variantCount='600'>
          <SupportEmail />
        </Text>
      </div>
    </div>
  )
}

export default ErrorContents
